/**
 * @license
 * Copyright (c) 2021-present, FriendliAI Inc. All rights reserved.
 */

import * as React from 'react';
import type { SVGProps } from 'react';
const SvgBulletYellow = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    color="transparent"
    viewBox="0 0 8 8"
    {...props}
  >
    <g filter="url(#bullet-yellow_svg__a)">
      <circle cx={4} cy={4} r={3} fill="#D7A114" />
    </g>
    <circle cx={4} cy={4} r={3.25} stroke="#906C0D" strokeWidth={0.5} />
    <defs>
      <filter
        id="bullet-yellow_svg__a"
        width={7}
        height={7}
        x={0.5}
        y={0.5}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1.25} />
        <feComposite in2="hardAlpha" k2={-1} k3={1} operator="arithmetic" />
        <feColorMatrix values="0 0 0 0 0.924674 0 0 0 0 0.815143 0 0 0 0 0.529144 0 0 0 1 0" />
        <feBlend in2="shape" result="effect1_innerShadow_2367_25876" />
      </filter>
    </defs>
  </svg>
);

export default SvgBulletYellow;
